import ChapterContentMain from "Pages/MyLibrary/FacultyContent/ChapterContent/ChapterContentMain";
import { Badge, Button, Tabs, Tag } from "antd";
import React, { useEffect, useState } from "react";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import { ToastContextDispatch } from "Context/CommonContext";
import ChapterContentFilter from "Pages/MyLibrary/FacultyContent/ChapterContent/ChapterContentFilter";
import { Space } from "antd";
import { useContext } from "react";
import {
  BASE_URL,
  GET_MASTER_TAGS,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import hasObjectHasNullValues from "utilFunctions/helperFunctions/utilFunctions";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
interface ChapterContentViewIF {
  selectedChapter: any;
  courseId: any;
}
const ChapterContentView = ({
  selectedChapter,
  courseId,
}: ChapterContentViewIF) => {
  const { screen }: any = useWindowSize();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [filterDataValue, setFilterDataValue] = useState<any>({});
  const [tabs, setTabs] = useState<any[]>([
    {
      key: "1",
      name: "Faculty Content",
      label: "Faculty Content",
      value: "facultyContent",
      filterListing: ["status", "segment", "search"],
      children: (
        <>
          <ChapterContentMain
            selectedChapter={selectedChapter}
            courseId={courseId}
            module={"facultyContent"}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            filterDataValue={filterDataValue}
            setFilterDataValue={setFilterDataValue}
          />
        </>
      ),
    },
    {
      key: "2",
      name: "Student Content",
      label: "Student Content",
      value: "studentContent",
      filterListing: ["status", "segment", "search"],
      children: (
        <>
          <ChapterContentMain
            selectedChapter={selectedChapter}
            courseId={courseId}
            module={"studentContent"}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            filterDataValue={filterDataValue}
            setFilterDataValue={setFilterDataValue}
          />
        </>
      ),
    },
  ]);
  const onChange = (key: string) => {
    setSelectedTabIndex(key);
  };
  useEffect(() => {
    console.log("selectedChapter====", selectedChapter);
    const tabs = [
      {
        key: "1",
        name: "Faculty Content",
        label: "Faculty Content",
        value: "facultyContent",
        filterListing: ["status", "segment", "search"],
        children: (
          <>
            <ChapterContentMain
              selectedChapter={selectedChapter}
              courseId={courseId}
              module={"facultyContent"}
              isDrawerOpen={isDrawerOpen}
              setIsDrawerOpen={setIsDrawerOpen}
              filterDataValue={filterDataValue}
              setFilterDataValue={setFilterDataValue}
            />
          </>
        ),
      },
      {
        key: "2",
        name: "Student Content",
        label: "Student Content",
        value: "studentContent",
        filterListing: ["status", "segment", "search"],
        children: (
          <>
            <ChapterContentMain
              selectedChapter={selectedChapter}
              courseId={courseId}
              module={"studentContent"}
              isDrawerOpen={isDrawerOpen}
              setIsDrawerOpen={setIsDrawerOpen}
              filterDataValue={filterDataValue}
              setFilterDataValue={setFilterDataValue}
            />
          </>
        ),
      },
    ];
    setTabs(tabs);
  }, [selectedChapter, filterDataValue]);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const [inputTags, setInputSets] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [filterState, setFilterState] = useState<any>({
    tags: null,
    assetType: null,
    title: null,
  });
  const { makeRequest: GetInputTags } = useGetApi(
    (data) => {
      if (data["data"] && data["data"].length > 0) {
        const inputArr = data["data"].map((ele: any) => {
          return {
            label: ele?.tagName,
            value: ele?.tagName,
            key: ele?.tagName,
          };
        });
        setInputSets(inputArr);
      } else {
        setInputSets([]);
      }
    },
    (error) => {
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    }
  );
  useEffect(() => {
    GetInputTags(BASE_URL + GET_MASTER_TAGS);
  }, []);
  console.log("selectedChapterselectedChapter", selectedChapter);
  const applyFilterHandler = (filterStateCopy: any) => {
    if (hasObjectHasNullValues(filterStateCopy)) {
      Object.keys(filterStateCopy).map((ele) => {
        const value = Array.isArray(filterStateCopy[ele])
          ? filterStateCopy[ele] &&
            filterStateCopy[ele].map((ele: any) => ele.value)
            ? filterStateCopy[ele].map((ele: any) => ele.value)
            : null
          : filterStateCopy[ele] != null && filterStateCopy[ele].value
          ? filterStateCopy[ele].value
          : filterStateCopy[ele]
          ? filterStateCopy[ele]
          : null;
        setFilterDataValue((prevState: any) => ({
          ...prevState,
          [ele]: value,
        }));
      });
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Please select atleast one filter",
      });
    }
  };
  const clearHandler = () => {
    const clearedFilter = {
      tags: null,
      assetType: null,
      title: null,
    };
    setFilterState(clearedFilter);
    setFilterDataValue({});
  };
  const newFilterState = JSON.parse(JSON.stringify(filterDataValue));
  delete newFilterState.endDate;
  const filterLength = Object.values(filterDataValue).filter(
    (ele) => ele != null
  ).length;
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={isDrawerOpen}
        setOpen={(val: any) => setIsDrawerOpen(val)}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-start">
              <Button
                type="primary"
                onClick={() => {
                  applyFilterHandler(filterState);
                  setIsDrawerOpen(false);
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              <Button onClick={() => setIsDrawerOpen(false)}>Close</Button>
              {filterLength > 0 && (
                <Button onClick={clearHandler}>Reset</Button>
              )}
            </Space>
          </>
        }
      >
        <ChapterContentFilter
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          filterState={filterState}
          setFilterState={setFilterState}
          inputTags={inputTags}
          filterDataValue={filterDataValue}
          setFilterDataValue={setFilterDataValue}
          clearAllHandler={() => {
            console.log("object");
          }}
          setSelectedChapter={selectedChapter}
          module={module}
        />
      </DrawerAntdComponent>
      <Tabs
        activeKey={selectedTabIndex}
        defaultActiveKey={selectedTabIndex}
        items={tabs}
        onChange={onChange}
        tabBarExtraContent={
          <Space>
            {filterLength != 0 && ["xxl", "xl", "lg"].includes(screen) && (
              <>
                {Object.keys(removeEmptyFields(filterState)).map((ele: any) => {
                  const displayValue =
                    selectedTabIndex === "2" &&
                    ele === "assetType" &&
                    typeof filterState[ele] === "string"
                      ? filterState[ele].replace(/^Faculty_/, "")
                      : filterState[ele];

                  return (
                    <Tag
                      key={ele}
                      style={{
                        textAlign: "center",
                        textTransform: "capitalize",
                      }}
                    >
                      {displayValue}
                    </Tag>
                  );
                })}
              </>
            )}
            <Badge count={filterLength}>
              <Button
                onClick={() => {
                  setIsDrawerOpen(true);
                }}
              >
                Filter
              </Button>
            </Badge>
            {filterLength > 0 && <Button onClick={clearHandler}>Reset</Button>}
          </Space>
        }
      ></Tabs>
    </>
  );
};

export default ChapterContentView;
